module.exports = __webpack_public_path__ + "img/c07_unitstartechwardogchampion_Normal_ua.1f5bce50.webp";